module.exports = __webpack_public_path__ + "media/images/suceess-story2-a4cafee4cc0bb4ed83d27e4e57d2aa40.jpg";